import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom'
import { Button, TextField } from '@mui/material';
import LogoImage from "../../assets/images/Group5502-svg.svg";
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../api/APIServices'
import { API_STATUS, USER_TYPE } from '../../constants';
import { FormControl } from '@mui/material';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';
import { InputLabel } from '@mui/material';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Languages from '../../components/Languages';
import BackgroundImage from '../../assets/images/clinicianloginbackgouund.png';

const ColorButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    borderRadius: 100,
    backgroundColor: '#003163',
    '&:hover': {
        backgroundColor: '#003163',
    },
}));


export default function Login() {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const { t } = useTranslation('global');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const initialFormValues = { email: '', password: '', userType: '' }
    const [formValues, setFormValues] = useState(initialFormValues);
    const [formErrors, setFormErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);
    const { status, errorMsg } = useSelector((state) => state.auth)

    function handleChange(e) {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value })
    }
    const [baseUrl, setBaseUrl] = useState();
    function handleChangeProvider(e) {
        const { name, value } = e.target;
        setBaseUrl(value);
        localStorage.setItem('baseUrl', value);
    }
    const [listAndPrompt, setListPrompt] = useState({
        list: [],
        prompt: 'Please select your provider',
        selectedURl: ''
    })

    useEffect(() => {
        getDropDownFields();
    }, []);

    const mainUrl = 'https://api.staging.modumhealth.net'; // USA

    const getDropDownFields = () => {
        fetch(mainUrl + '/providerlist', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(response => response.json())
            .then(json => {
                // console.log(json);
                const list = json?.providers.map((e, index) => {
                    return {
                        id: index,
                        value: e?.baseUrl,
                        label: e?.name,
                        url: e?.baseUrl
                    }
                });
                // console.log(list, 'list=========');
                setListPrompt({ list: list, prompt: json?.prompt, selectedURl: '' })
            })
            .catch(error => {
                console.error(error);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmit(true)
    }

    function validate(values) {
        const error = {}
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
        if (!values.email) {
            error.email = 'email is required';
        } else if (formValues.userType !== 'user' && !regex.test(values.email)) {
            error.email = 'enter valid email format';
        }
        if (!values.password.trim()) {
            error.password = 'Password is required';
        }
        return error;
    };


    useEffect(() => {
        if (isLoggedIn) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (userInfo && userInfo.userType === USER_TYPE.USER) {
                navigate('/userDashboard');
            } else {
                navigate('/home');
            }

        }
    }, [isLoggedIn])

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            dispatch(loginUser(formValues));
        }
    }, [formErrors]);



    return (
        <div style={{
            backgroundImage: `url(${BackgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100vh',
            width: '100%',
        }}>

            <div className='prehead' style={{ background: 'white' }}>
                <div >
                    <div style={{
                        marginLeft: '20px',
                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                        <img style={{ borderRadius: '5px', width: '60%', background: 'white' }} src={LogoImage} />
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Languages />
                </div>
            </div>
            <div style={{
                height: ' 100%',
                width: '100%',
                backgroundColor: 'rgba(10, 132, 255, 0.5)'  // Same color, 50% transparent

            }}>
                <div className='center'>


                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>

                        <div style={{ width: '50%', backgroundColor: '#FFF', padding: '15px', borderRadius: '10px' }}>


                            <div style={{
                                padding: '10px'
                            }}>
                                <div style={{
                                    padding: '20px',
                                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                                }}>
                                    <img style={{ borderRadius: '5px', width: '30%' }} src={LogoImage} />
                                </div>
                                {/* <Typography variant="h4" sx={{ marginBottom: '10px', fontWeight: 600 }}>{t('login')}</Typography> */}
                                {status === 'error' && <Typography sx={{ fontSize: '10px', marginBottom: '10px', color: 'red' }}>{errorMsg}</Typography>}
                                <form onSubmit={handleSubmit}>
                                    {listAndPrompt.list.length !== 0 && <FormControl sx={{ m: 0, width: '100%', paddingRight: '5px', whiteSpace: 'pre-wrap' }} size="small">
                                        <InputLabel id="demo-select-small-label">{t('pleaseSelectYourProvider')}</InputLabel>
                                        <Select
                                            name='provider'
                                            label={t('pleaseSelectYourProvider')}
                                            value={baseUrl}
                                            onChange={handleChangeProvider}
                                        >
                                            {listAndPrompt.list?.map((e) => (
                                                <MenuItem key={e.id} value={e.value}>
                                                    {e.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    }
                                    <FormControl sx={{ m: 0, width: '100%', paddingRight: '5px', whiteSpace: 'pre-wrap', marginTop: '15px' }} size="small">
                                        <InputLabel id="demo-select-small-label">{t('loginAs')}</InputLabel>
                                        <Select
                                            name='userType'
                                            label={t('loginAs')}
                                            value={formValues.userType}

                                            onChange={handleChange}
                                        >
                                            <MenuItem value={USER_TYPE.CLINICIAN}>{t('clinician')}</MenuItem>
                                            <MenuItem value={USER_TYPE.USER}>{t('user')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <TextField size='small' name="email" type={formValues.userType === 'user' ? "text" : "email"} label={formValues.userType === 'user' ? t('userNameorEmail') : t('email')} variant="outlined"
                                        sx={{ marginTop: '15px', width: '100%', marginBottom: '15px', borderRadius: '20px' }}
                                        onChange={handleChange}

                                        error={formErrors.email ? true : false}
                                    />
                                    <TextField size='small' name="password" type="password" label={t('password')}
                                        variant="outlined"
                                        sx={{ marginBottom: '25px', width: '100%' }}
                                        onChange={handleChange}

                                        error={formErrors.password ? true : false}
                                    />
                                    <div style={{ display: 'flex', marginBottom: '15px', justifyContent: 'space-between' }}>
                                        <div style={{ fontSize: '11px' }}> </div>
                                        <div style={{ fontSize: '11px' }}>
                                            <Link >
                                                {t('forgotPassword')}
                                            </Link>
                                        </div>
                                    </div>

                                    <div >
                                        {status === API_STATUS.PENDING && <div>{t('loading')}</div>}

                                        {(status === API_STATUS.IDEL || status === API_STATUS.ERROR) && <ColorButton
                                            sx={{ width: '100%' }}
                                            type="submit"
                                        >
                                            {t('login')}
                                        </ColorButton>}
                                    </div>

                                </form>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
